<template>
    <v-expansion-panels
            class="mb-4"
    >
        <v-expansion-panel>
            <v-expansion-panel-header> Tìm kiếm theo nhân viên xuất sắc</v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-card
                        class="ma-0 overflow-visible"
                        outlined
                >
                    <v-list-item class="pa-0" three-line>
                        <v-list-item-content class="overflow-visible pa-0">
<!--                            <v-list-item-title class="headline mb-2">-->
<!--                                Tìm Kiếm-->
<!--                            </v-list-item-title>-->
                            <v-row>
                                <v-col cols="12" md="8">
                                    <common-range-picker
                                            :aLight="'center'"
                                            :clearable="true"
                                            :defaultRange="defaultRange"
                                            @change-date-range="changeDateRange"
                                    />
                                </v-col>
                            </v-row>
                            <div class="text-center mb-4">
                                <v-btn
                                        class="primary mx-0"
                                        @click="searchBestEmployees"
                                >
                                    <v-icon>mdi-magnify</v-icon>Tìm kiếm
                                </v-btn>
                            </div>
                        </v-list-item-content>
                    </v-list-item>
                </v-card>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>
<script>
    import * as moment from 'moment'
    export default {
        props: {
            filterForm: {
                default: () => ({}),
            },
        },
        data () {
            return {
                defaultRange: {
                    startDate: moment().startOf('month').format('YYYY-MM-DD'),
                    endDate: moment().endOf('month').format('YYYY-MM-DD'),
                },
            }
        },
        created () {

        },
        methods: {
            searchBestEmployees() {
                Bus.$emit('best-employees-list-filter', this.filterForm)
            },
            changeDateRange (dateRange) {
                this.filterForm.dateRange = dateRange
            }
        }
    }
</script>